export default {"src":"/_next/static/media/failed.07323eee.svg","height":512,"width":512};